//packages
import React, { Component } from 'react'

//images
import loadingBarImg from '../../../images/loadingBar.gif';

//styles
import './LoadingBar.less'

class LoadingBar extends Component {
    render() {
        return (
            <img className="loading-bar" src={ loadingBarImg }/>
        )
    }
}

export default LoadingBar



/** WEBPACK FOOTER **
 ** ./src/components/Modules/LoadingBar/LoadingBar.js
 **/